module.exports = __webpack_public_path__ + "static/media/sardine_tomatosauce.45402158.jpg";